export const ENVIRONMENT_TYPE: string = process.env.REACT_APP_ENV ?? "DEV";

interface configInterface {
  baseApiUrl: string;
  RAZORPAY_KEY_ID: string;
}

const DEV_CONFIG: configInterface = {
  baseApiUrl: "https://uat.starnex.co/api/",
  RAZORPAY_KEY_ID: "rzp_test_C7fy08DOl0xpTW",
};

const PROD_CONFIG: configInterface = {
  baseApiUrl: "https://app.starnex.co/api/",
  RAZORPAY_KEY_ID: "rzp_live_3F1ZdAfF59nG56",
};

const selector = () => {
  // switch (ENVIRONMENT_TYPE) {
  //   case "DEV":
  //     return PROD_CONFIG;
  //   case "PROD":
  //     return PROD_CONFIG;
  //   default:
  //     return PROD_CONFIG;
  // }
  // return DEV_CONFIG;
  return PROD_CONFIG;
};

export const CONFIG = selector();
